<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    :width="size"
    :height="size"
  >
    <polygon
      :points="pointTop + ' ' + pointLeft + ' ' + pointRight"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      :fill="fill"
    />
  </svg>
</template>
<script>
export default {
  name: 'icon-triangle',
  props: {
    size: {
      type: Number,
      default: 18,
    },
    stroke: {
      type: String,
      default: '#606266',
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
  computed: {
    iconHeight() {
      return this.size * Math.cos(Math.PI / 6)
    },
    pointTop() {
      return (
        this.size / 2 +
        ',' +
        ((this.size - this.iconHeight) / 2 + this.strokeWidth / 2)
      )
    },
    pointLeft() {
      return (
        this.strokeWidth / 2 +
        ',' +
        (this.iconHeight +
          (this.size - this.iconHeight) / 2 -
          this.strokeWidth / 2)
      )
    },
    pointRight() {
      return (
        this.size -
        this.strokeWidth / 2 +
        ',' +
        (this.iconHeight +
          (this.size - this.iconHeight) / 2 -
          this.strokeWidth / 2)
      )
    },
  },
}
</script>